import {
  Card,
  Typography,
  Input,
  Button,
  Form,
  // Empty,
  Checkbox,
  Divider,
  Select,
  Radio,
  DatePicker,
} from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { changeLoader } from "../../../redux/reducers/loader";
import globalRequest from "../../../utils/global/globalRequest";
import * as Validation from "../../../utils/helper/validation";
import * as Apis from "../../../utils/helper/enum";
import { useDispatch } from "react-redux";
// import config from "../../../config";
import { jwtDecode } from "jwt-decode";
import { addDeleteGetLocalStorage, storageKeys } from "../../../utils/global/localData";
import { checkPermissionAction, formatDateFunction } from "../../../utils/helper/utils";
import toast from "react-hot-toast";
import { useEffect, useState } from "react";
import dayjs from "dayjs";

const discountTypeList = [
  { value: "flat", label: "Flat" },
  { value: "flat_cap", label: "Flat Cap" },
  { value: "percentage", label: "Percentage" },
];

const discountLevelList = [
  { value: "system_level", label: "System Level" },
  { value: "vendor_level", label: "Vendor Level" },
];

const CreateCoupon = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const [discountType, setDiscountType] = useState("flat");
  const [discountLevel, setDiscountLevel] = useState("system_level");
  const [selectVendors, setSelectVendors] = useState([]);

  let { id } = useParams();

  useEffect(() => {
    const userAccess = addDeleteGetLocalStorage(storageKeys?.USER_TOKEN, {}, "get");
    let permissionJson = [];
    if (userAccess) {
      const decoded = jwtDecode(userAccess);
      permissionJson = decoded?.user?.rolePermission?.permissionJson;
    }
    if (id) {
      if (!checkPermissionAction("Manage Coupon", permissionJson, "edit")) {
        navigate("/manage-coupon");
      }
    } else {
      if (!checkPermissionAction("Manage Coupon", permissionJson, "add")) {
        navigate("/manage-coupon");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInputChange = (name) => {
    form.setFields([
      {
        name,
        errors: [],
      },
    ]);
  };

  const handleSubmit = async (values) => {
    values.couponExpiryDate = formatDateFunction(values.couponExpiryDate, "yyyy-mm-dd");
    // console.log(values); return false;
    if (values.discountType === "percentage" && values.couponAmount > 100) {
      // Check if couponAmount is greater than 100
      form.setFields([
        {
          name: "couponAmount",
          errors: ["Coupon percentage cannot be greater than 100"],
        },
      ]);
      return; // Stop form submission
    }
    dispatch(changeLoader(true));
    try {
      let url = Apis?.MANAGE_COUPON?.CREATE_COUPON;
      let method = "post";
      if (id) {
        url = Apis?.MANAGE_COUPON?.EDIT_COUPON + "/" + id;
        method = "put";
      }
      let response = await globalRequest(url, method, values, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Coupon created successfully";
        if (id) msg = "Coupon updated successfully";
        toast.success(msg, {
          duration: 2000,
        });
        navigate("/manage-coupon");
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  const getCouponDetail = async (id) => {
    try {
      let response = await globalRequest(Apis.MANAGE_COUPON.GET_COUPON_DETAIL + "/" + id, "get", {}, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let data = apiResponse?.data;
        form.setFieldValue("couponCode", data?.couponCode);
        form.setFieldValue("discountType", data?.discountType);
        setDiscountType(data?.discountType);

        form.setFieldValue("discountLevel", data?.discountLevel);
        setDiscountLevel(data?.discountLevel);

        form.setFieldValue("couponAmount", data?.couponAmount);
        form.setFieldValue("couponExpiryDate", dayjs(data?.couponExpiryDate, "YYYY-MM-DD"));
        form.setFieldValue("minimumSpend", data?.minimumSpend);
        form.setFieldValue("maximumDiscountValue", data?.maximumDiscountValue);
        form.setFieldValue("usageLimitForCustomer", data?.usageLimitForCustomer);
        form.setFieldValue("usageLimitOfCoupon", data?.usageLimitOfCoupon);
        form.setFieldValue("appliedOnDeliveryType", data?.appliedOnDeliveryType);
        form.setFieldValue("appliedOn", data?.appliedOn);

        let ides = data?.vendor_ids.map(Number);
        form.setFieldValue("vendor_ids", ides);
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  const disabledDate = (current) => {
    // Disable dates before today
    return current && current.isBefore(dayjs().startOf("day"));
  };

  //Get vendor Data
  const getVendorData = async () => {
    dispatch(changeLoader(true));
    let response = await globalRequest(Apis.MANAGE_COUPON.VENDOR_LIST, "get", {}, {}, true);
    if (response?.status === 200) {
      let data = response?.data?.data;
      let vendorData = [];
      if (data && data.length > 0)
        for (let item of data) {
          if (item?.vendorDetail?.vendor_type !== "host") {
            vendorData.push({
              value: item?.id,
              label: item?.vendorDetail?.storeName,
            });
          }
        }
      setSelectVendors(vendorData);
    } else {
      // toast.error(apiResponse?.message);
    }
    dispatch(changeLoader(false));
  };

  useEffect(() => {
    if (id) getCouponDetail(id);
    getVendorData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <Card>
        <div className="flex items-center justify-between relative mb-4">
          <Typography className="text-xl font-semibold mb-0" align={"left"}>
            <LeftOutlined onClick={() => navigate(-1)} className="text=lg text-black mr-2 cursor-pointer" />
            {id ? "Edit" : "Create"} Coupon
          </Typography>
        </div>
        <Divider />
        <div className="mb-0 flex justify-between flex-wrap">
          <Form
            layout="vertical"
            style={{
              maxWidth: 1000,
              width: "100%",
            }}
            initialValues={{
              remember: true,
            }}
            autoComplete="off"
            form={form}
            onFinish={handleSubmit}
          >
            <div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6">
                <Form.Item
                  label="Coupon Code"
                  name="couponCode"
                  rules={[
                    {
                      required: true,
                      message: "Please enter Coupon Code.",
                    },
                    {
                      max: 25,
                      message: "Maximum 25 characters",
                    },
                  ]}
                >
                  <Input
                    size="large"
                    maxLength={25}
                    onChange={(e) => {
                      form.setFieldValue("couponCode", e.target.value.trimStart());
                      handleInputChange("couponCode");
                    }}
                  />
                </Form.Item>
                <Form.Item
                  label="Discount Type"
                  name="discountType"
                  rules={[
                    {
                      required: true,
                      message: "Please Select Discount Type.",
                    },
                  ]}
                >
                  <Select
                    className="w-full"
                    size="large"
                    placeholder="Select"
                    showSearch
                    filterOption={(input, discountTypeList) => (discountTypeList?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                    options={discountTypeList}
                    onChange={(e) => {
                      setDiscountType(e);
                    }}
                  />
                </Form.Item>

                <Form.Item
                  label={discountType === "flat" || discountType === "flat_cap" ? "Coupon Amount" : "Coupon Percentage"}
                  name="couponAmount"
                  rules={[
                    {
                      required: true,
                      message: "Please enter Coupon Percentage.",
                    },
                  ]}
                >
                  <Input
                    size="large"
                    maxLength={10}
                    addonAfter={discountType === "flat" || discountType === "flat_cap" ? "SAR" : "%"}
                    onChange={(e) => {
                      let value = Validation.strFormat(e.target.value, "number");
                      form.setFieldValue("couponAmount", value.trimStart());
                      handleInputChange("couponAmount");
                    }}
                  />
                </Form.Item>

                <Form.Item
                  label="Coupon Expiry Date"
                  name="couponExpiryDate"
                  rules={[
                    {
                      required: true,
                      message: "Please select Coupon Expiry Date.",
                    },
                  ]}
                >
                  <DatePicker format="DD-MM-YYYY" className="h-[39px] w-full" disabledDate={disabledDate} />
                </Form.Item>
                <Form.Item
                  label="Minimum Spend"
                  name="minimumSpend"
                  rules={[
                    {
                      required: true,
                      message: "Please enter Coupon Amount.",
                    },
                  ]}
                >
                  <Input
                    size="large"
                    maxLength={10}
                    addonAfter="SAR"
                    onChange={(e) => {
                      let value = Validation.strFormat(e.target.value, "number");
                      form.setFieldValue("minimumSpend", value.trimStart());
                      handleInputChange("minimumSpend");
                    }}
                  />
                </Form.Item>
                <Form.Item
                  label="Maximum Discount Value"
                  name="maximumDiscountValue"
                  rules={[
                    {
                      required: true,
                      message: "Please enter Coupon Amount.",
                    },
                  ]}
                >
                  <Input
                    size="large"
                    maxLength={10}
                    addonAfter="SAR"
                    onChange={(e) => {
                      let value = Validation.strFormat(e.target.value, "number");
                      form.setFieldValue("maximumDiscountValue", value.trimStart());
                      handleInputChange("maximumDiscountValue");
                    }}
                  />
                </Form.Item>
                <Form.Item
                  label="Usage limits for customers"
                  name="usageLimitForCustomer"
                  rules={[
                    {
                      required: true,
                      message: "Please enter Usage limits for customers.",
                    },
                  ]}
                >
                  <Input
                    size="large"
                    maxLength={10}
                    onChange={(e) => {
                      let value = Validation.strFormat(e.target.value, "number");
                      form.setFieldValue("usageLimitForCustomer", value.trimStart());
                      handleInputChange("usageLimitForCustomer");
                    }}
                  />
                </Form.Item>
                <Form.Item
                  label="No of coupon to be used"
                  name="usageLimitOfCoupon"
                  rules={[
                    {
                      required: true,
                      message: "Please enter No of coupon to be used.",
                    },
                  ]}
                >
                  <Input
                    size="large"
                    maxLength={10}
                    onChange={(e) => {
                      let value = Validation.strFormat(e.target.value, "number");
                      form.setFieldValue("usageLimitOfCoupon", value.trimStart());
                      handleInputChange("usageLimitOfCoupon");
                    }}
                  />
                </Form.Item>

                <Form.Item
                  label="Discount Level"
                  name="discountLevel"
                  rules={[
                    {
                      required: true,
                      message: "Please select Discount Level.",
                    },
                  ]}
                >
                  <Select
                    className="w-full"
                    size="large"
                    placeholder="Select"
                    showSearch
                    filterOption={(input, discountLevelList) =>
                      (discountLevelList?.label ?? "").toLowerCase().includes(input.toLowerCase())
                    }
                    options={
                      discountType === "flat_cap" 
                        ? [{ value: "vendor_level", label: "Vendor Level" }]
                        : discountLevelList
                    }
                    onChange={(e) => {
                      setDiscountLevel(e);
                    }}
                  />
                </Form.Item>

                {discountLevel === "vendor_level" ? (
                  <Form.Item
                    label="Vendors"
                    name="vendor_ids"
                    rules={[
                      {
                        required: true,
                        message: "Please select Vendors.",
                      },
                    ]}
                  >
                    <Select
                      className="w-full"
                      size="large"
                      placeholder="Select"
                      mode="multiple"
                      showSearch
                      filterOption={(input, selectVendors) => (selectVendors?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                      options={selectVendors}
                      // onChange={(e) => {
                      //   setSelectVendors(e);
                      // }}
                    />
                  </Form.Item>
                ) : null}

                <Form.Item
                  label="Applicable on"
                  name="appliedOnDeliveryType"
                  rules={[
                    {
                      required: true,
                      message: "Please enter Applicable on.",
                    },
                  ]}
                >
                  <Checkbox.Group>
                    <Checkbox value="delivery">Delivery Orders</Checkbox>
                    <Checkbox value="pickup">Pickup Orders</Checkbox>
                    {/* <Checkbox value="both">Both</Checkbox> */}
                  </Checkbox.Group>
                </Form.Item>
                <Form.Item
                  label="To be Applied on"
                  name="appliedOn"
                  rules={[
                    {
                      required: true,
                      message: "Please enter To be Applied on.",
                    },
                  ]}
                >
                  <Radio.Group>
                    {discountType !== "flat_cap" ? <Radio value="sub-total">Sub Total (including VAT)</Radio> : null}
                    <Radio value="delivery-fee">Delivery Fee</Radio>
                    {discountType !== "flat_cap" ? <Radio value="grand-total">Grand Total</Radio> : null}
                    {/* <Radio value="grand-total">Grand Total</Radio> */}
                  </Radio.Group>
                </Form.Item>
              </div>
            </div>
            <div className="flex justify-end gap-3">
              <Button className="w-[100px] h-[39px]" onClick={() => navigate("/manage-coupon")}>
                Cancel
              </Button>
              <Button type="primary" className="w-[100px] h-[39px]" htmlType="submit">
                {id ? "Edit" : "Create"} Coupon
              </Button>
            </div>
          </Form>
        </div>
      </Card>
    </>
  );
};
export default CreateCoupon;
